// extracted by mini-css-extract-plugin
export default {"error":"ErrorUi_error__tMkNQ","fadeIn":"ErrorUi_fadeIn__+sivK","button":"ErrorUi_button__yzo5z"};